import { check, PERMISSIONS, RESULTS, openSettings } from 'react-native-permissions';

const checkBackgroundAndForegroundLocationPermissionsGranted = async () => {
  const backgroundLocationResult = await checkBackgroundLocationPermissionGranted();
  const foregroundLocationResult = await checkForegroundLocationPermissionsGranted();

  return backgroundLocationResult || foregroundLocationResult;
};

const checkBackgroundLocationPermissionGranted = async () => {
  const result = await check(PERMISSIONS.ANDROID.ACCESS_BACKGROUND_LOCATION);
  return result === RESULTS.GRANTED;
};

const checkForegroundLocationPermissionsGranted = async () => {
  const coarseLocationResult = await check(PERMISSIONS.ANDROID.ACCESS_COARSE_LOCATION);
  const fineLocationResult = await check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
  return coarseLocationResult === RESULTS.GRANTED || fineLocationResult === RESULTS.GRANTED;
};
const getBackgroundOverlayVisibility = async isVisible => {
  const isBackgroundLocationPermissionGranted = await checkBackgroundLocationPermissionGranted();
  return !isBackgroundLocationPermissionGranted && isVisible ? true : false;
};

export {
  getBackgroundOverlayVisibility,
  openSettings,
  checkForegroundLocationPermissionsGranted,
  checkBackgroundLocationPermissionGranted,
  checkBackgroundAndForegroundLocationPermissionsGranted,
};
